import { ProgressStepState } from '../store/types';

export const generateStep = (
  stepName: string,
  stepIndex: number,
  accountTypeRoute: string,
  applicantIndex: number
): ProgressStepState => {
  let step = { step: 0, name: '', url: '', status: '' };

  switch (stepName) {
    case 'About you':
      step = {
        step: stepIndex,
        name: stepName,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/about-you`,
        status: 'disabled',
      };
      break;
    case 'Verify your identity':
      step = {
        step: stepIndex,
        name: stepName,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/verify-identity`,
        status: 'disabled',
      };
      break;
    case 'Tax details':
      step = {
        step: stepIndex,
        name: stepName,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/tax-details`,
        status: 'disabled',
      };
      break;
    case 'Account details':
      step = {
        step: stepIndex,
        name: stepName,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/account-details`,
        status: 'disabled',
      };
      break;
    case 'Financial details':
      step = {
        step: stepIndex,
        name: stepName,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/financial-details`,
        status: 'disabled',
      };
      break;
    case 'Next applicant':
      step = {
        step: stepIndex,
        name: `Applicant ${applicantIndex + 1}`,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/next-applicant`,
        status: 'disabled',
      };
      break;
    case 'Additional cardholder':
      step = {
        step: stepIndex,
        name: `Additional cardholder`,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/next-applicant`,
        status: 'disabled',
      };
      break;
    case 'Child applicant':
      step = {
        step: stepIndex,
        name: `Child applicant`,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/next-applicant`,
        status: 'disabled',
      };
      break;
    case 'Review & submit':
      step = {
        step: stepIndex,
        name: stepName,
        url: `/${accountTypeRoute}/applicants/${applicantIndex}/review`,
        status: 'disabled',
      };
      break;
    default:
  }

  return step;
};

export const generateMemberSteps = (
  steps: string[],
  accountTypeRoute: string,
  applicantIndex: number
): ProgressStepState[] => {
  let memberSteps = steps.map((step, index) => {
    return generateStep(step, index + 1, accountTypeRoute, applicantIndex);
  });
  return memberSteps;
};
